import { LearningType } from "./LearningType";
import { useTranslation } from "react-i18next";
import LearningTypeCell from "./LearningTypeCell";
import styles from "./LearningTypeSelectDialog.module.css";

interface LearningTypeSelectDialogProps {
  open: boolean;
  onSelect: (type: LearningType) => void;
  onClose: () => void;
}

export default function LearningTypeSelectDialog(
  props: LearningTypeSelectDialogProps
) {
  const { t } = useTranslation();

  const handleClickScreen = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (event.target === event.currentTarget) {
      props.onClose();
    }
  };

  if (props.open === false) {
    return null;
  }

  return (
    <>
      <div className={styles.stack}>
        <div className={styles.screen} onClick={handleClickScreen}>
          <div className={styles.container}>
            <div className={styles.topContainer}>
              <span className={styles.titleText}>
                {t("LearningReviewSelectGameMessage")}
              </span>
            </div>
            <div className={styles.learningTypeContainer}>
              <LearningTypeCell
                type={LearningType.flashcards}
                image="iconImgStudyFlash.png"
                title={t("Flashcard")}
                description=""
                style="list"
                onClick={() => {
                  props.onSelect(LearningType.flashcards);
                }}
              />
              <LearningTypeCell
                type={LearningType.multiplechoice}
                title={t("MultipleChoiceTitle")}
                description={t("MultipleChoiceExplain")}
                image="iconImgStudy1For4.png"
                style="list"
                onClick={() => {
                  props.onSelect(LearningType.multiplechoice);
                }}
              />
              <LearningTypeCell
                type={LearningType.spellingQuiz}
                title={t("SpellingQuiz")}
                description={t("SpellQuizExplain")}
                image="iconImgStudySpelling.png"
                style="list"
                onClick={() => {
                  props.onSelect(LearningType.spellingQuiz);
                }}
              />
            </div>
            <div className={styles.buttonContainer}></div>
          </div>
        </div>
      </div>
    </>
  );
}
